// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"6026705c","595":"e59d749d","621":"20a55259","788":"54280600"}[chunkId] + ".chunk.js";
};